import React, { Component } from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';

const Wrapper = styled.div`
  display: ${props => props.isShowPalette ? 'block' : 'none'};
  position: absolute;
  right: 72px;
  top: calc(100vh - 80px);
  z-index: 20;

  ${media.w1200`
    right: 40px;
  `}
  ${media.tablet`
    top: calc(100vh - 120px);
  `}
  ${media.mobile`
    right: 10px;
  `}
  ${media.iphone67p`
    top: 570px;
  `}
  ${media.iphone67`
    top: 500px;
  `}
`;

/** Button */
const Circle = Flex.extend`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: solid 1px #eeeeee;
  box-shadow: 1px 1px 8px 2px rgba(0,0,0,0.3);
  background: ${props => props.palette ? '#ffffff' : props.color};
  cursor: pointer;
  animation: up-down .75s infinite alternate;

  &:active {
    box-shadow: none;
  }

  @keyframes spaceboots {
    0% { -webkit-transform: translate(2px, 1px) rotate(0deg); }
    10% { -webkit-transform: translate(-2px, -1px) rotate(-1deg); }
    20% { -webkit-transform: translate(-3px, 0px) rotate(1deg); }
    30% { -webkit-transform: translate(0px, 2px) rotate(0deg); }
    40% { -webkit-transform: translate(1px, -1px) rotate(1deg); }
    50% { -webkit-transform: translate(-1px, 2px) rotate(-1deg); }
    60% { -webkit-transform: translate(-3px, 1px) rotate(0deg); }
    70% { -webkit-transform: translate(2px, 1px) rotate(-1deg); }
    80% { -webkit-transform: translate(-1px, -1px) rotate(1deg); }
    90% { -webkit-transform: translate(2px, 2px) rotate(0deg); }
    100% { -webkit-transform: translate(1px, -2px) rotate(-1deg); }
  }

  @keyframes up-down {
    0% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(-32px);
    }
  }
`;

class TogglePalette extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  render() {
    const { color, palette, openPalette, isShowPalette } = this.props;

    return (
      <Wrapper isShowPalette={isShowPalette}>
        <Circle onClick={openPalette} color={color} palette={palette}/>
      </Wrapper>
    );
  };
}

export default TogglePalette;



// WEBPACK FOOTER //
// ./src/components/Shared/TogglePalette.js